import { VersionLogApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useVersionLogAPI(): VersionLogApi {
  return new VersionLogApi(apiConfig);
}
